import ArrowRightIcon from "@assets/icons/arrowRight"
import EmailIcon from "@assets/icons/email"
import PatientInfoBackgroundIcon from "@assets/icons/patientInfoBackground"
import { Button } from "@components/Button"
import FullpageLoadingState from "@components/Common/FullpageLoadingState"
import usePatient from "@hooks/usePatient"
import PhoneInput from "react-phone-input-2"
import "react-phone-input-2/lib/style.css"
import { useSelector } from "react-redux"
import { useEffect, useState } from "react"
import { notify } from "src/utils/notify"

const PatientInfo = ({
  setAppointmentStage,
  appointmentDetails,
  setAppointmentDetails,
  setShowFilters,
  setFilterToBeExpanded,
  setActiveFilterField,
  activeFilterField,
  patientData,
  paginationState,
}) => {
  const { handleGetPatient } = usePatient()
  const { isFindPatientLoading } = useSelector((state) => state.patient)

  const currentFormFields = ["email", "firstName", "lastName", "contact"]
  const isDisabled = !currentFormFields.every((item) => {
    return appointmentDetails[item] ? true : false
  })

  // Handle opening filters for different fields
  const handleFieldClick = (field) => {
    setActiveFilterField(field)
    setFilterToBeExpanded(
      field === "email"
        ? "Email"
        : field === "contact"
          ? "Contact"
          : field === "firstName"
            ? "First Name"
            : "Last Name"
    )
    setShowFilters(true)
  }

  // Listen for changes in paginationState and update form fields
  useEffect(() => {
    if (patientData && patientData.length > 0) {
      // Find the patient that matches the filter criteria
      const filteredValue = paginationState[activeFilterField]

      if (filteredValue) {
        // Find matching patient based on activeFilterField
        const matchedPatient = patientData.find((patient) => {
          // Access nested properties using the correct path
          if (
            activeFilterField === "firstName" ||
            activeFilterField === "lastName" ||
            activeFilterField === "email" ||
            activeFilterField === "contact"
          ) {
            return (
              String(patient.local[activeFilterField]) === String(filteredValue)
            )
          }
          return false
        })

        if (matchedPatient && matchedPatient.local) {
          // Update all form fields with the matched patient's data from the nested structure
          setAppointmentDetails((prev) => ({
            ...prev,
            firstName: matchedPatient.local.firstName,
            lastName: matchedPatient.local.lastName,
            contact: matchedPatient.local.contact,
            email: matchedPatient.local.email,
            patientId: matchedPatient._id,
          }))

          // console.log(
          //   "Patient selected:",
          //   matchedPatient.local.firstName,
          //   matchedPatient.local.lastName
          // )
        }
      }
    }
  }, [paginationState, patientData, activeFilterField, setAppointmentDetails])

  return (
    <>
      {isFindPatientLoading ? <FullpageLoadingState /> : null}
      <div className="relative h-[25rem] rounded-2xl sm:bg-[--pure-white] flex justify-center sm:justify-normal overflow-y-scroll no-scrollbar">
        <div className="absolute bottom-0 right-0 z-[1] hidden xl:block">
          <PatientInfoBackgroundIcon />
        </div>

        <div className="flex flex-col gap-4 w-full max-w-[25rem] px-4 pb-4 bg-[--pure-white] rounded-2xl sm:px-10 sm:py-8 h-max z-10">
          <div className="flex gap-4">
            <div className="flex flex-col gap-2">
              <label
                htmlFor="firstName"
                className="text-[#344054] text-sm font-medium"
              >
                First name*
              </label>
              <div
                className="flex justify-between items-center rounded-lg px-4 py-2 border border-[--primary-blue] cursor-pointer"
                onClick={() => handleFieldClick("firstName")}
              >
                <input
                  id="firstName"
                  placeholder="first name"
                  className="w-full cursor-pointer pointer-events-none"
                  disabled={true}
                  value={appointmentDetails.firstName || ""}
                  readOnly
                />
                <ArrowRightIcon />
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <label
                htmlFor="lastName"
                className="text-[#344054] text-sm font-medium"
              >
                Last name*
              </label>
              <div
                className="flex justify-between items-center rounded-lg px-4 py-2 border border-[--primary-blue] cursor-pointer"
                onClick={() => handleFieldClick("lastName")}
              >
                <input
                  id="lastName"
                  placeholder="last name"
                  className="w-full cursor-pointer pointer-events-none"
                  disabled={true}
                  value={appointmentDetails.lastName || ""}
                  readOnly
                />
                <ArrowRightIcon />
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <label
              htmlFor="email"
              className="text-[#344054] text-sm font-medium"
            >
              Email*
            </label>
            <div
              className="flex justify-between gap-2 items-center rounded-lg px-3 py-2 border border-[--primary-blue] cursor-pointer"
              onClick={() => handleFieldClick("email")}
            >
              <EmailIcon />
              <input
                value={appointmentDetails.email || ""}
                className="w-full cursor-pointer pointer-events-none"
                id="email"
                placeholder="email@gmail.com"
                type="email"
                disabled={true}
                readOnly
              />
              <ArrowRightIcon />
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <label
              htmlFor="contact"
              className="text-[#344054] text-sm font-medium"
            >
              Contact*
            </label>
            <div
              className="cursor-pointer"
              onClick={() => handleFieldClick("contact")}
            >
              <PhoneInput
                disabled
                value={appointmentDetails.contact || ""}
                country="in"
                containerStyle={{
                  width: "100%",
                  border: "1px solid var(--primary-blue)",
                  pointerEvents: "none",
                }}
                inputStyle={{
                  width: "100%",
                  border: "none",
                  color: "#344054",
                  borderRadius: "8px",
                  cursor: "pointer",
                  pointerEvents: "none",
                }}
                inputProps={{
                  placeholder: "0000000000",
                  readOnly: true,
                }}
                buttonStyle={{
                  border: "none",
                  backgroundColor: "transparent",
                  pointerEvents: "none",
                }}
              />
            </div>
          </div>

          <Button
            disabled={isDisabled}
            onClick={() => {
              setAppointmentStage(1)
            }}
            className="!font-bold"
          >
            SAVE AND NEXT
          </Button>
        </div>
      </div>
    </>
  )
}

export default PatientInfo
